module.exports = __webpack_public_path__ + "static/img/gxsj.026d3ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxsj.png
// module id = niWX
// module chunks = 1